import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProfileRepository } from './../../data/services/profile-respository.service';
import { AppValidators } from './../../core/validators/app-validators';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import constants from '../../utility/constants';
import messages from '../../utility/messages';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  passwordChangeForm: FormGroup;
  submitting: boolean = false;
  fieldMaxLength = constants.common.validations.maxLength50;
  isMatch: boolean = false;
  hide = true;
  hide2 = true;
  hide3 = true;
  private subscriptions: Array<Subscription> = [];

  constructor(
    private ps: ProfileRepository,
    private toast: ToastrService,
    public modalRef: BsModalRef
  ) {}

  ngOnInit() {
    this.passwordChangeForm = new FormGroup(
      {
        oldPassword: new FormControl(null, Validators.required),
        newPassword: new FormControl(null, [
          Validators.required,
          AppValidators.checkPassword,
          Validators.maxLength(this.fieldMaxLength),
        ]),
        confirmPassword: new FormControl(null, [
          Validators.required,
          Validators.maxLength(this.fieldMaxLength),
        ]),
      },
      this.matchPassword.bind(this)
    );
  }

  matchPassword(controls: FormControl): { [s: string]: boolean } {
    let pswd = controls.value.newPassword;
    let cpswd = controls.value.confirmPassword;
    if (pswd != null && cpswd != null) {
      if (pswd != cpswd || cpswd != pswd) {
        this.isMatch = false;
        return { passwordMismatch: true };
      }
    } else {
      this.isMatch = true;
      return null;
    }
  }

  onSubmit() {
    if (this.passwordChangeForm.invalid) {
      return;
    }

    this.submitting = true;

    const changePwd = this.ps
      .changePassword(
        this.passwordChangeForm.value.oldPassword,
        this.passwordChangeForm.value.newPassword
      )
      .subscribe(
        () => {
          this.submitting = false;
          this.toast.success(
            messages.changePassword.changeSuccess,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
          this.modalRef.hide();
        },
        (err) => {
          this.submitting = false;
          this.toast.error(
            err,
            constants.common.toast.errorTitle,
            constants.common.toast.config
          );
        }
      );
    this.subscriptions.push(changePwd);
  }
  hideandreset() {
    this.passwordChangeForm.reset();
    this.modalRef.hide();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
